import React, { useState, useRef, useEffect, useCallback } from 'react'
import {
  FormattedMessage,
  injectIntl,
} from 'react-intl'
import { useNavigate, useLocation } from 'react-router-dom'
import NavigationBar from '../../partials/NavigationBar'
import {
  DivAccount,
  AuthCard,
  Title,
  MessageError,
  TitleError,
  Message,
  StyledInput,
  Label,
  Foot,
  ButtonWhite,
} from './styledComponents'

const Password = function Password (props) {
  const passwordInput = useRef()
  const confirmPasswordInput = useRef()
  const navigate = useNavigate()
  const location = useLocation()

  const [error, setError] = useState('')
  const [errorFields, setErrorFields] = useState([])

  // Equivalent to componentDidMount
  useEffect(() => {
    const { password } = props.values
    if (password !== null) {
      passwordInput.current.value = password
      confirmPasswordInput.current.value = password
    }
  }, [props.values])

  const validate = useCallback(() => {
    const {
      intl: {
        formatMessage,
      },
    } = props

    const newErrorFields = []
    const password = passwordInput.current.value
    const confirmPassword = confirmPasswordInput.current.value

    if (password.length < 8) {
      newErrorFields.push('password')
      setErrorFields(newErrorFields)
      return (
        formatMessage({
          id: 'auth.changePassword.invalid.useAtLeast',
          defaultMessage: 'Password should have at least 8 characters',
          description: 'Password should have at least 8 characters',
        })
      )
    }

    if (password.trim().length === 0) {
      newErrorFields.push('password')
      setErrorFields(newErrorFields)
      return (
        formatMessage({
          id: 'auth.changePassword.invalid.charactersAndNumbers',
          defaultMessage: 'Passwords must contain characters and/or numbers',
          description: 'Passwords must contain characters and/or numbers',
        })
      )
    }

    if (password !== confirmPassword) {
      newErrorFields.push('password', 'confirmPassword')
      setErrorFields(newErrorFields)
      return (
        formatMessage({
          id: 'auth.changePassword.invalid.noMatch',
          defaultMessage: 'Passwords do not match',
          description: 'Passwords do not match',
        })
      )
    }

    // Empty means no errors, so IT IS valid input
    setErrorFields([])
    return ''
  }, [props.intl])

  const next = useCallback(() => {
    const validationError = validate()
    if (validationError) {
      setError(validationError)
      window.scrollTo(0, 0)
    } else {
      const password = passwordInput.current.value
      const { onNext } = props
      onNext({ password })
    }
  }, [validate, props])

  const hasError = useCallback((f) => errorFields.includes(f), [errorFields])

  const { onPrevious } = props

  return (
    <div>
      <DivAccount>
        <NavigationBar
          page={location.pathname}
          logOut={() => props.auth.logout(navigate)}
        />
        <AuthCard>

          <Title>
            <FormattedMessage
              id='auth.changePassword.create'
              defaultMessage='Create Password'
              description='Create Password label'
            />
          </Title>

          {
            error && (
              <MessageError>
                <TitleError>
                  <FormattedMessage
                    id='auth.changePassword.invalid.label'
                    defaultMessage='INVALID PASSWORD'
                  />
                </TitleError>
                <Message>
                  {error}
                </Message>
              </MessageError>
            )
          }
          <form>
            <Label>
              <FormattedMessage
                id='auth.changePassword.new'
                defaultMessage='Choose a New Password'
                description='Choose a New Password label'
              />
              <StyledInput
                ref={passwordInput}
                error={hasError('password')}
                type='password'
                autoFocus
                required
              />
            </Label>
            <Foot>
              <FormattedMessage
                id='auth.changePassword.useAtLeast'
                defaultMessage='Use at least 8 characters'
                description='Use at least 8 characters label'
              />
            </Foot>

            <Label>
              <FormattedMessage
                id='auth.changePassword.confirm'
                defaultMessage='Confirm New Password'
                description='Confirm New Password label'
              />
              <StyledInput
                ref={confirmPasswordInput}
                error={hasError('confirmPassword')}
                type='password'
                required
              />
            </Label>
            <Foot>
              <FormattedMessage
                id='auth.changePassword.reenter'
                defaultMessage='Reenter your password'
                description='Reenter your password label'
              />
            </Foot>
          </form>

          <ButtonWhite onClick={next}>
            <FormattedMessage
              id='resetPassword.next'
              defaultMessage='NEXT'
              description='NEXT label'
            />
          </ButtonWhite>
        </AuthCard>
      </DivAccount>
    </div>
  )
}

export default injectIntl(Password)
